import type { FaireProductEntity } from "../../entity_types/product";

export const p_awfmen9ga3: FaireProductEntity = {
  token: "p_awfmen9ga3",
  type: "product",
  name: "Blueberries Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f722c44584f7d726db6965bfec512fb913e609210a6a0e500d9e5ea95a2a1d16.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b941686b18ba1e1eb686359dfdc787c2d93f63d7035dd6c5a08d634439c186fe.jpeg",
    "https://cdn.faire.com/fastly/1006cc6baab6142692077fbff52c42470ebf56570802a8a48b0ac62f1e7dd4ea.jpeg",
    "https://cdn.faire.com/fastly/1021fa1caa99c1b3cf392405b834d12fffea2ec55c2b91e0c6f42436681e77ec.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:47.945Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
